import { ReactNode } from 'react';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue
} from '../ui/select';
import { Label } from '../ui/label';

export interface CustomSelectOption {
  value: string;
  label: string | ReactNode;
}

export interface CustomSelectProps {
  id?: string;
  label?: string;
  value: string;
  onValueChange: (value: string) => void;
  placeholder?: string;
  options: CustomSelectOption[];
  className?: string;
  error?: string;
  fullWidth?: boolean;
  disabled?: boolean;
}

export default function CustomSelect({
  id,
  label,
  value,
  onValueChange,
  placeholder,
  options,
  className = '',
  error,
  fullWidth = false,
  disabled = false
}: Readonly<CustomSelectProps>) {
  return (
    <div className='mb-4'>
      {label && <Label className='mb-2 block'>{label}</Label>}
      <Select
        value={value || ''}
        onValueChange={onValueChange}
        disabled={disabled}
      >
        <SelectTrigger
          id={id}
          className={className}
          fullWidth={fullWidth}
          disabled={disabled}
        >
          <SelectValue placeholder={placeholder} />
        </SelectTrigger>
        <SelectContent>
          {options.length > 0 ? (
            options.map((option) => (
              <SelectItem key={option.value} value={option.value}>
                {option.label}
              </SelectItem>
            ))
          ) : (
            <div className='px-2 py-1.5 text-sm text-gray-500'>
              No options available
            </div>
          )}
        </SelectContent>
      </Select>
      {error && (
        <div className='text-red-500 text-xs mt-1 ml-1 text-align-left'>
          {error}
        </div>
      )}
    </div>
  );
}
